import Nullstack from 'nullstack';
export default function IconFishHook({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-fish-hook",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 9v6a5 5 0 0 1 -10 0v-4l3 3"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "7",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M16 5v-2"
  }), " ");
}